// Polyfill for markdown-it isSpace function
// This fixes the "isSpace is not defined" error in markdown-it

if (typeof window !== 'undefined' && !window.isSpace) {
  window.isSpace = function(code) {
    switch (code) {
      case 0x09: // \t
      case 0x20: // space
        return true;
    }
    return false;
  };
}

// Also add to global scope for Node.js environments
if (typeof global !== 'undefined' && !global.isSpace) {
  global.isSpace = function(code) {
    switch (code) {
      case 0x09: // \t
      case 0x20: // space
        return true;
    }
    return false;
  };
}

export default function ensureIsSpace() {
  // Ensure isSpace is available
  if (typeof window !== 'undefined' && !window.isSpace) {
    window.isSpace = function(code) {
      switch (code) {
        case 0x09: // \t
        case 0x20: // space
          return true;
      }
      return false;
    };
  }
}